import {ExternalLink} from 'lucide-react';
import {Dialog, DialogContent, DialogTitle} from '@common-web/components/ui/dialog';
import {Button} from '@common-web/components/ui/button';

export interface ViewableFile {
  url: string;
  name: string | null;
  contentType: string;
}

export function FileView({url, name, contentType}: ViewableFile) {
  return contentType.startsWith('image/') ? (
    <img src={url} alt={name ?? ''} className='max-h-full max-w-full object-contain' />
  ) : (
    <iframe src={url} title={name ?? 'Preview'} className='h-full w-full rounded-sm bg-white' />
  );
}

// A file shown full screen over the page.
export function FileViewerDialog({
  file,
  onOpenChange,
}: {
  file: ViewableFile;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby={undefined}
        className='flex h-[100dvh] w-screen max-w-none flex-col gap-0 border-0 bg-gray-950 p-0 text-white sm:max-w-none sm:rounded-none [&>button:last-child]:text-white'
      >
        <div className='flex items-center gap-3 py-3 pl-5 pr-14'>
          <DialogTitle className='min-w-0 flex-1 truncate text-sm font-medium'>
            {file.name}
          </DialogTitle>
          <Button
            variant='ghost'
            size='icon'
            className='h-7 w-7 shrink-0 text-white hover:bg-white/10 hover:text-white'
            aria-label='Open in new tab'
            title='Open in new tab'
            onClick={() => window.open(file.url, '_blank')}
          >
            <ExternalLink className='h-4 w-4' />
          </Button>
        </div>
        <div className='flex min-h-0 flex-1 items-center justify-center px-4 pb-4'>
          <FileView {...file} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
